// extracted by mini-css-extract-plugin
export default {"container":"OpenEnd_container__VTIGx","placeholderTitle":"OpenEnd_placeholderTitle__6ZOeq","textarea":"OpenEnd_textarea__OL5Wq"};